module.exports = __webpack_public_path__ + "static/buy-35d9b1a431d65854e3df631489e2533a.png";